<template>
  <form class="form">
  <div class="form-group">
    <div class="input-group">
      <textarea id="tops" class="form-control" v-model="formData.new_customer_note"></textarea>
    </div>
  </div>
  <CustomerNote
    :key="customer_note.id"
    v-for="(customer_note, index) in notes"
    :customer_note="customer_note"
    :customer_id="customer_id"
    :index="index"
    @customerNoteDeleted="updateCustomerNotes"
  />
  <div class="buttons">
    <button @click="createCustomerNote" type="submit" name="submit" class="btn btn--primary" :disabled="formData.new_customer_note == null || formData.new_customer_note == ''">
      Save
    </button>
  </div>
  </form>
</template>

<script>
import api from '../api'

import CustomerNote from '../components/CustomerNote.vue';

export default {
  name: 'Customer notes',
  components: {
    CustomerNote
  },
  props: {
    customer_id: {
      type: String,
      default: null,
    },
    new_customer_note: {
      type: String,
      default: null
    },
    customer_notes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      notes: this.customer_notes,
      formData: {
        new_customer_note: this.new_customer_note,
      }
    }
  },
  mounted() {
    api.getCustomerNotes(this.$route.params.customer_id).then(customer_notes => {
      this.notes = customer_notes;
    }).catch(error => {
      console.log(error);
    });
  },
  emits: ["customerNoteSubmitted"],
  methods: {
    createCustomerNote(e) {
      e.preventDefault()
      var newFormData = {
        content: this.formData.new_customer_note,
        customer_id: this.$props.customer_id,
      }
      api.createCustomerNote(newFormData).then(customer_note => {
        console.log(customer_note)
        this.updateCustomerNotes()
        this.formData.new_customer_note = ''
      })
    },
    updateCustomerNotes() {
      api.getCustomerNotes(this.customer_id).then(customer_notes => {
        this.notes = customer_notes
      }).catch(error => {
        console.log(error);
      });
    },
    removeCustomerNote(e) {
      e.preventDefault()
      let params = {
        customer_id: this.$props.customer_id,
        customer_note_id: e.target.id
      }
      api.deleteCustomerNote(params).then(customer_note => {
        this.$emit('customerNoteDeleted', customer_note, e.target)
      })
    },
  },
}
</script>

<style scoped>
  textarea {
    resize: none;
    padding: 30px;
    height: 200px;
  }
</style>
